import * as React from "react";

import { getClassCApps } from "../helpers";
import { GridBase } from "./GridBase";

export function ClassCGrid({classC}) {
    const apps = getClassCApps(classC);

    return <GridBase
        limit={30}
        items={apps.filter((x) => x.imgwhite != null)}
        withLink={(x) => {
            return `/docs/unified-api/class-c/${x.slug}/`;
        }}
    />;
}
